import { useTheme } from "@mui/material";
import { TrendingUp } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationEditButton } from "web_myplann/Inspiration/Components/InspirationEditButton";
import { InspirationNudgeSection } from "web_myplann/Inspiration/Components/InspirationNudgeSection";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import { InspirationValueCard } from "web_myplann/Inspiration/Components/InspirationValueCard";
import type { EarlyFreedomContext } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

const R = Resources.Inspiration.EarlyFreedom;

type Props = {
	context: EarlyFreedomContext;
	onEdit: () => void;
};

export const EarlyFreedomPassiveSection: FC<Props> = ({ context, onEdit }) => {
	const { t } = useResource();
	const theme = useTheme();

	if (context.passiveToday <= 0) {
		return (
			<InspirationNudgeSection
				title={t(R.passiveTitle)}
				description={t(R.passiveLiteDescription)}
				icon={TrendingUp}
				nudgeTitle={t(R.passiveNudgeTitle)}
				nudgeText={t(R.passiveNudgeText)}
				onOpen={onEdit}
			/>
		);
	}

	return (
		<InspirationSection
			title={t(R.passiveTitle)}
			rightAction={<InspirationEditButton label={t(R.edit)} onClick={onEdit} />}
		>
			<InspirationValueCard
				label={t(R.passiveFullLabel)}
				value={formatInspirationMoney(context.passiveToday)}
				unit={t(R.perMonth)}
				valueColor={theme.palette.green.main}
			/>
		</InspirationSection>
	);
};
